import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ToastService } from '../../../common-services/Toast/ToastService';
import { QueueReportJobOutput } from '../../../models/QueueReportJobOutput';
import { strings } from '../../../resources/strings';
import { ReportService } from '../ReportService';
import { GenerateShippingGuideReportInput } from './GenerateShippingGuideReportInput';

export class GenerateShippingGuideReportService extends HttpServiceBase {

  constructor(
    private report: ReportService,
    private toaster: ToastService,
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GenerateShippingGuideReportInput, version?: number, callback?: (success: boolean) => void) => {
    const urlVersion = version && version > 0 ? `/v${version}` : '';
    this.http.postToDownloadFile<GenerateShippingGuideReportInput>(
      `${this.baseUrlSislogV2Api}/v2/report-shipping-guide${urlVersion}`,
      input
    ).then(result => {
      this.report.openPdf(result);
      callback?.(true);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingReport);
      callback?.(false);
    });
  }

  queueJob = (input: GenerateShippingGuideReportInput): Promise<Result<QueueReportJobOutput> | null> => {
    const promise = this.http.post<Result<QueueReportJobOutput>, GenerateShippingGuideReportInput>(
      `${this.baseUrlSislogV2Api}/v2/report-shipping-guide/job`, input
    );
    return promise;
  }
}